<template>
  <div class="line-box">
    <v-container class="box" fill-height>
      <v-row class="mb-6" justify="center" align="center">
        <v-col lg="7" md="7">
          <v-card class="mx-auto" style="min-width: 30%">
            <v-list-item style="background-color: #141824">
              <v-list-item-content>
                <v-list-item-title class="headline" style="color: #ffb600"
                  >Line Token Manage</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-card-text style="padding-bottom: 0px">
              <v-data-table
                :headers="headers"
                :items="datasets"
                hide-default-footer
                height="550px"
                :items-per-page="1000"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>LINE TOKEN</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="ค้นหา"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" persistent max-width="500px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="success"
                          dark
                          class="mb-2"
                          v-bind="attrs"
                          v-on="on"
                          @click="resetAdd()"
                        >
                          <v-icon light style="color: #fff"
                            >mdi-plus-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title
                          style="background-color: #141824; color: #ffb600"
                        >
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-form v-model="valid">
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-autocomplete
                                    prepend-icon="mdi-domain"
                                    v-model="editedItem.company_name"
                                    :items="companys"
                                    item-text="fullname"
                                    item-value="username"
                                    hide-details="auto"
                                    outlined
                                    dense
                                    @change="getCondition()"
                                    chips
                                    small-chips
                                    label="บริษัท/ห้างหุ้นส่วน"
                                    :rules="rules.company_name"
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip small class="chip--select-multi">
                                        {{ data.item.fullname }}
                                      </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                      <template>
                                        <v-list-item-content
                                          v-text="data.item.fullname"
                                        ></v-list-item-content>
                                      </template>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    outlined
                                    dense
                                    prepend-icon="mdi-key-variant"
                                    hide-details="auto"
                                    v-model="editedItem.line_token"
                                    :rules="rules.token"
                                    label="Line Token"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-autocomplete
                                    readonly
                                    v-model="editedItem.province"
                                    :items="provinces"
                                    hide-details="auto"
                                    prepend-icon="mdi-clipboard-check-multiple"
                                    color="blue-grey lighten-2"
                                    outlined
                                    :rules="rules.province"
                                    dense
                                    chips
                                    small-chips
                                    label="จังหวัด"
                                    item-text="name_th"
                                    item-value="id"
                                    multiple
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip
                                        close
                                        small
                                        class="chip--select-multi"
                                        @click:close="removeProvince(data.item)"
                                      >
                                        {{ data.item.name_th }}
                                      </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                      <template
                                        v-if="typeof data.item !== 'object'"
                                      >
                                        <v-list-item-content
                                          v-text="data.item"
                                        ></v-list-item-content>
                                      </template>
                                      <template v-else>
                                        <v-list-item-content
                                          v-html="data.item.name_th"
                                        ></v-list-item-content>
                                      </template>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-autocomplete
                                    readonly
                                    prepend-icon="mdi-clipboard-check-multiple"
                                    v-model="editedItem.type_job"
                                    :items="typeworks"
                                    item-text="job_type_name"
                                    item-value="job_type_id"
                                    hide-details="auto"
                                    outlined
                                    dense
                                    chips
                                    small-chips
                                    label="ประเภทงาน"
                                    multiple
                                    :rules="rules.typework"
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip
                                        close
                                        small
                                        class="chip--select-multi"
                                        @click:close="removeType(data.item)"
                                      >
                                        {{ data.item.job_type_name }}
                                      </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                      <template>
                                        <v-list-item-content
                                          v-text="data.item.job_type_name"
                                        ></v-list-item-content>
                                      </template>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  lg="12"
                                ></v-col>
                                <v-col cols="12" sm="12" md="12" lg="12">
                                  <v-slider
                                    label="ระดับคะเเนน"
                                    prepend-icon="mdi-shield-star"
                                    v-model="editedItem.cust_level"
                                    :max="5"
                                    step="1"
                                    thumb-label="always"
                                    ticks="always"
                                    tick-size="6"
                                  ></v-slider>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    outlined
                                    dense
                                    prepend-icon="mdi-map-marker-radius"
                                    hide-details="auto"
                                    v-model="editedItem.latitude"
                                    :rules="rules.token"
                                    label="latitude"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    outlined
                                    dense
                                    prepend-icon="mdi-map-marker-radius-outline"
                                    hide-details="auto"
                                    v-model="editedItem.longitude"
                                    :rules="rules.token"
                                    label="longitude"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="6">
                                  <v-switch
                                    v-model="editedItem.ads_status"
                                    label="โฆษณา"
                                    color="success darken-3"
                                    false-value="1"
                                    true-value="0"
                                    hide-details
                                    dense
                                  ></v-switch>
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="6">
                                  <v-switch
                                    v-model="editedItem.enable"
                                    label="เเจ้งเตือน"
                                    color="success darken-3"
                                    false-value="1"
                                    true-value="0"
                                    dense
                                    hide-details
                                  ></v-switch>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            small
                            :disabled="!valid"
                            color="success darken-1"
                            @click="saveItemComfirm()"
                          >
                            บันทึก
                          </v-btn>
                          <v-btn small color="error" @click="close()">
                            ยกเลิก
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="saveDialog" persistent max-width="350px">
                      <v-card>
                        <v-card-title class="headline"
                          >ยืนยันการทำรายการหรือไม่?
                        </v-card-title>
                        <v-card-text></v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="success darken-1" small @click="save()"
                            >ยืนยัน</v-btn
                          >
                          <v-btn
                            small
                            color="error darken-1"
                            text
                            @click="closeSaveConfirm()"
                            >ยกเลิก</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-left">{{ item.name_com }}</td>
                    <td class="text-left">{{ item.company_name }}</td>
                    <td class="text-left">{{ item.line_token }}</td>
                    <td
                      class="text-center"
                      style="color: green; font-weight: bold"
                      v-if="item.ads_status === '0'"
                    >
                      <v-icon small color="success"> mdi-check-bold </v-icon>
                    </td>
                    <td
                      class="text-center"
                      style="color: red; font-weight: bold"
                      v-else
                    >
                      <v-icon small color="error"> mdi-close-thick </v-icon>
                    </td>
                    <td
                      class="text-center"
                      style="color: green; font-weight: bold"
                      v-if="item.enable === '0'"
                    >
                      <v-icon small color="success"> mdi-check-bold </v-icon>
                    </td>
                    <td
                      class="text-center"
                      style="color: red; font-weight: bold"
                      v-else
                    >
                      <v-icon small color="error"> mdi-close-thick </v-icon>
                    </td>
                    <td class="text-center">
                      <v-icon
                        class="mr-2"
                        color="warning"
                        @click="editItem(item)"
                      >
                        mdi-pencil
                      </v-icon>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data> พบ LINE TOKEN 0 รายการ </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "linetoken",
  data: () => ({
    valid: false,
    companys: [],
    typeworks: [],
    provinces: [],
    search: "",
    level_labels: [],
    headers: [
      {
        text: "บริษัท/ห้างหุ้นส่วน",
        align: "start",
        sortable: false,
        value: "name_com",
      },
      {
        text: "รหัสประจำตัวผู้เสียภาษี",
        align: "start",
        sortable: false,
        value: "company_name",
      },
      {
        text: "Line Token Code",
        align: "start",
        sortable: false,
        value: "line_token",
      },
      {
        text: "โฆษณา",
        align: "center",
        sortable: false,
        value: "ads_status",
      },
      {
        text: "เเจ้งเตือน",
        align: "center",
        sortable: false,
        value: "enable",
      },
      {
        text: "แก้ไข",
        align: "center",
        sortable: false,
        value: "actions",
      },
    ],
    datasets: [],
    dialog: false,
    saveDialog: false,
    editedIndex: -1,
    editedItem: {
      id: null,
      type_job: null,
      province: null,
      line_token: null,
      company_name: null,
      ads_status: "0",
      enable: "0",
      created_by: null,
      module: null,
      version: null,
      browser: null,
      ipaddress: null,
      fullname: null,
      name_com: null,
      cust_level: 0,
      latitude: null,
      longitude: null
    },
    rules: {
      typework: [(v) => !!v || "กรุณาเลือกประเภทงาน"],
      province: [(v) => !!v || "กรุณาเลือกจังหวัด"],
      token: [(v) => !!v || "กรุณากรอก Token"],
      company_name: [(v) => !!v || "กรุณากรอกชื่อบริษัท/ห้างหุ้นส่วน"],
    },
  }),
  mounted() {
    if (localStorage.getItem("username") !== null) {
      if (localStorage.getItem("role") !== "Admin") {
        alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");
        this.$router.push("/login");
      }
      //----------
    }
   if (localStorage.getItem("username") === undefined) {
            alert("กรุณาลงชื่อเข้าสู่ระบบก่อน");
            this.$router.push("/login");
          } else {
            this.getAllJob();
            this.getAllProvince();
            this.getAllToken();
            this.getUser();
          }
    // this.$axios.get(this.api + "/get/list_level").then((res) => {
    //   if (res.data.response) {
    //     this.level_labels = res.data.response;
    //   }
    // });
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่มข้อมูล" : "เเก้ไขข้อมูล";
    },
  },
  methods: {
    resetAdd() {
      this.editedIndex = -1;
    },
    getCondition() {
      this.$axios
        .post(this.api + "/get/condition", {
          company: this.editedItem.company_name,
        })
        .then((res) => {
          if (res.data.status) {
            this.editedItem.province = [];
            this.editedItem.type_job = [];
            for (
              let index = 0;
              index < res.data.response[0].province.split(",").length;
              index++
            ) {
              this.editedItem.province.push(
                parseInt(res.data.response[0].province.split(",")[index])
              );
            }
            for (
              let index = 0;
              index < res.data.response[0].type_job.split(",").length;
              index++
            ) {
              this.editedItem.type_job.push(
                res.data.response[0].type_job.split(",")[index]
              );
            }
          }
        });
    },
    getUser() {
      this.$axios.get(this.api + "/all/user/guest").then((res) => {
        if (res.data.status) {
          this.companys = res.data.response;
      
        }
      });
    },
    getAllToken() {
      this.$axios.get(this.api + "/all/token").then((res) => {
        if (res.data.status) {
          this.datasets = res.data.response;
          for (let index = 0; index < this.datasets.length; index++) {
            this.datasets[index].province = this.datasets[index].province.split(
              ","
            );
            this.datasets[index].type_job = this.datasets[index].type_job.split(
              ","
            );
          }
        }
      });
    },
    getAllJob() {
      this.$axios.get(this.api + "/all/typejob").then((res) => {
        if (res.data.status) {
          this.typeworks = res.data.response;
        }
      });
    },
    getAllProvince() {
      this.$axios.get(this.api + "/all/province").then((res) => {
        if (res.data.status) {
          for (let index = 0; index < res.data.response.length; index++) {
            if (index === 0) {
              this.provinces.push(JSON.parse('{"header": "ภาคใต้"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 14) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันออก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 21) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันตก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 26) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(
                JSON.parse('{"header": "ภาคตะวันออกเฉียงเหนือ"}')
              );
              this.provinces.push(res.data.response[index]);
            } else if (index === 46) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคกลาง"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 68) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคเหนือ"}'));
              this.provinces.push(res.data.response[index]);
            } else {
              this.provinces.push(res.data.response[index]);
            }
          }
        }
      });
    },
    removeType(item) {
      let index = this.editedItem.type_job.indexOf(item.job_type_id);
      if (index >= 0) this.editedItem.type_job.splice(index, 1);
    },
    removeProvince(item) {
      let index = this.editedItem.province.indexOf(item.id);
      if (index >= 0) this.editedItem.province.splice(index, 1);
    },
    editItem(item) {
      console.log(item)
      for (let index = 0; index < item.province.length; index++) {
        item.province[index] = parseInt(item.province[index].replace(/'/g, ""));
      }
      for (let index = 0; index < item.type_job.length; index++) {
        item.type_job[index] = item.type_job[index].replace(/'/g, "");
      }
      this.editedIndex = this.datasets.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.editedItem.type_job = null;
      this.editedItem.province = null;
      this.editedItem.line_token = null;
      this.editedItem.company_name = null;
      this.editedItem.ads_status = "0";
      this.editedItem.enable = "0";
      this.editedItem.cust_level = 0;
      this.valid = false;
      this.dialog = false;
    },
    saveItemComfirm() {
      this.saveDialog = true;
    },
    closeSaveConfirm() {
      this.saveDialog = false;
    },
    save() {
      this.editedItem.fullname = localStorage.getItem("fullname");
      this.editedItem.created_by = localStorage.getItem("username");
      this.editedItem.version = this.version;
      this.editedItem.browser =
        this.$browserDetect.meta.name +
        " V." +
        this.$browserDetect.meta.version;
      this.editedItem.ipaddress = localStorage.getItem("ipaddress");
      if (this.editedIndex === -1) {
        this.editedItem.module = "เพิ่ม Line Token";
        this.$axios
          .post(this.api + "/add/token", this.editedItem)
          .then((res) => {
            if (res.data.status) {
              location.reload();
            }
          });
      } else {
        this.editedItem.module = "เเก้ไข Line Token";
        this.$axios
          .post(this.api + "/update/token", this.editedItem)
          .then((res) => {
            if (res.data.status) {
              location.reload();
            }
          });
      }
    },
  },
};
</script>

<style>
.box {
  height: 94vh;
  margin: auto;
}
</style>
